import React, { useState,useEffect } from "react";
import { Card, Row, Col, Spin, Form, Input, Button,Modal,Tabs,Select  } from "antd";
import * as util from '../Helpers/Util';
import history from "../../history";
import queryString, { parse } from "query-string";
import CreateBasvuruWithYibfNo from '../../services/createBasvuruWithYibfNo';
import tapuMahalleList from "../../services/tapuMahalleList";
import getAdaParselList from "../../services/adaParselList";
import basvuruOlustur from "../../services/basvuruOlustur";
import iskanParentBasvuruOlustur from "../../services/iskanParentBasvuruOlustur";

const { Option } = Select;
const parsed = queryString.parse(history.location.search);
const { TabPane } = Tabs;
const formLayout = {
  labelCol: {
    span: 2,
  },
  wrapperCol: {
    span: 8,
  },
};

const CreateBasvuruWithYibfNoForm = () => {
  const [spining, setSpining] = useState(false);
  const [tusForm] = Form.useForm();
  const [yapiDenetimForm] = Form.useForm();
  const [mahalles, setMahalles] = useState([]);
  const [adaParsel, setAdaParsel] = useState([]);

  const load = async() => {
    await tapuMahalleList().then(res => { console.log(res.data.result); setMahalles(res.data.result) });
  }

  const getAdaParsel = async(mahId) => {    
    setSpining(true);

    await setAdaParsel([]);
    await getAdaParselList( { "TapuMahalleId" : mahId }).then(resp => setAdaParsel(resp.data.result));

    setSpining(false);
  }

  useEffect(() => {
    load();
  },[]);

  const YapiDenetimForm = () => {
    return (
      <Form form={yapiDenetimForm} {...formLayout} onFinish={yapiOnFinish} name="YapiDenetimForm">
      <Form.Item
        label="YİBF No"
        name="yibfNo"
        labelAlign="left"
        rules={[{ required: true, message: "Lüften YİBF No giriniz" }]}
      >
        <Input type="number" />
      </Form.Item>
      <Row>
        <Col span={6} style={{ textAlign: "right" }}>
          <Button type="primary" htmlType="submit">
            Kaydet
          </Button>
        </Col>
      </Row>
    </Form>
    );
  }

  const TusForm = () => {
    return (
      <Form form={tusForm} {...formLayout} onFinish={tusOnFinish} name="TusForm">
       <Form.Item
        label="Mahalle"
        name="Mahalle"
        labelAlign="left"
        rules={[{ required: true, message: "Lüften Mahalle bilgisini giriniz" }]}
      >
            <Select
                showSearch
                allowClear
                onChange={getAdaParsel}               
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Mahalle"
               
            >
                {mahalles && mahalles.map(bt => <Option key={bt.objectid} value={bt.objectid}>{bt.adi}</Option>)}
            </Select>
        </Form.Item>
        <Form.Item
        label="Ada/Parsel"
        name="AdaParsel"
        rules={[{ required: true, message: "Lüften Ada/Parsel bilgisini giriniz" }]}
        labelAlign="left"
      >
            <Select
                showSearch
                allowClear
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Ada/Parsel"
               
            >
                {adaParsel && adaParsel.map(bt => <Option  key={bt.objectId} value={bt.objectId}>{bt.adaParsel}</Option>)}
            </Select>
        </Form.Item>
      <Row>
        <Col span={6} style={{ textAlign: "right" }}>
          <Button type="primary" htmlType="submit">
            Kaydet
          </Button>
        </Col>
      </Row>
    </Form>
    );
  }

  const tabList = [
    {
      key: "1",
      label: "Yapı Denetim",
      children: <YapiDenetimForm />,
    },
    {
      key: "2",
      label: "TUS",
      children: <TusForm />,
    },
  ];

  const yapiOnFinish = async (values) => {
    setSpining(true);
    let filterModel= {};

    filterModel.YibfNo =  values['yibfNo'];
    filterModel.AltSurecTipiId = parsed['altSurecTipiId'];



    await CreateBasvuruWithYibfNo(filterModel).then(resp => {
      if(resp.data.success){
        var result = resp.data.result;
        window.location.replace(window.location.origin + '/belnet/genericclass/GenelBFormu.aspx?&KODU=' + result.BasvuruId +'&BFORM='+ result.BasvuruFormUrl + '&belge_turu_id='+result.BelgeTuruId +'&alt_surec_tipi_id='+ result.AltSurecTipiId +'&parent_objectid='+result.ParentBasvuruId + '&nomaster=true');
      }else{
        util.errorMessage(resp.data.message);
      }
    }).catch(ex => {
      util.errorMessage(String(ex.message))
    });
    setSpining(false);
  };

  const tusOnFinish = async(values) => {

    // console.log("tusOnFinish",tusForm.getFieldsValue());
    setSpining(true);

    let parentBasvuruFilter= {
      BelgeTuruId :  11,
      BelgeGrubuId : 11,
      TapuMahalleId : values['Mahalle'],
      ParselId : values['AdaParsel'],
      YapiDenetimVarMi : 0
    };

    await iskanParentBasvuruOlustur(parentBasvuruFilter).then(async resp => {
      if(resp.data.success){
        let basvuruFilter= {
          altSurecTipiId :  parseInt(parsed['altSurecTipiId']),
          parentObjectId : resp.data.result.objectid,
        };

      //  console.log("basvuruFilter",basvuruFilter)
    
        await basvuruOlustur(basvuruFilter).then(basvuruResp => {
          if(basvuruResp.data.success){
            var result = basvuruResp.data.result;
            window.location.replace(window.location.origin + '/belnet/genericclass/GenelBFormu.aspx?&KODU=' + result.BasvuruId +'&BFORM='+ result.BasvuruFormUrl + '&belge_turu_id='+result.BelgeTuruId +'&alt_surec_tipi_id='+ result.AltSurecTipiId +'&parent_objectid='+result.ParentBasvuruId + '&nomaster=true');
          }else{
            util.errorMessage(basvuruResp.data.message);
          }
        }).catch(ex => {
          util.errorMessage(String(ex.message))
        });
      }else{
        util.errorMessage(resp.data.message);
      }
    }).catch(ex => {
      util.errorMessage(String(ex.message))
    })

    setSpining(false);
  }

  return (
      <Spin tip={"Veriler yükleniyor/sorgulanıyor..."} spinning={spining}>
        <Card bodyStyle={{ padding: "10", fontWeight: "bold" }}>
          YİBF No Başvurusu
        </Card>
        
        <Tabs  style={{paddingLeft:20}} defaultActiveKey={1} >
          {tabList.map((tab) => {
            const { key, label, children } = tab;
            return (
              <Tabs.TabPane
                key={key}
                tab={label}
                style={{ margin: "1.5rem auto 1.5rem" }}
              >
                {children}
              </Tabs.TabPane>
            );
          })}
        </Tabs>;
      </Spin>
  );
};

export default CreateBasvuruWithYibfNoForm;
